export const handleEnterAsTab = (e: React.KeyboardEvent<HTMLElement>) => {
  if (e.key !== 'Enter') return;

  const rawTarget = e.target as HTMLElement;
  if (rawTarget.tagName.toLowerCase() === 'textarea') return;

  e.preventDefault();

  const form = rawTarget.closest('form');
  if (!form) return;

  const focusableSelector = 'input:not([type="hidden"]), select, textarea, button, [tabindex]:not([tabindex="-1"])';

  const target =
    (rawTarget.matches(focusableSelector) ? rawTarget : rawTarget.closest<HTMLElement>(focusableSelector)) ??
    (document.activeElement as HTMLElement | null);

  if (!target) return;

  const focusable = Array.from(form.querySelectorAll<HTMLElement>(focusableSelector)).filter((el) => {
    const isDisabled =
      el.hasAttribute('disabled') ||
      el.getAttribute('aria-hidden') === 'true' ||
      (el as HTMLInputElement).type === 'hidden';
    const isInvisible = el.offsetParent === null && el !== document.activeElement && el.getClientRects().length === 0;
    return !isDisabled && !isInvisible;
  });

  let index = focusable.indexOf(target);
  if (index === -1) {
    const active = document.activeElement as HTMLElement | null;
    index = active ? focusable.indexOf(active) : -1;
  }
  if (index === -1) return;

  let next: HTMLElement | undefined = undefined;
  for (let i = index + 1; i < focusable.length; i++) {
    const el = focusable[i];
    if (typeof (el as any).focus === 'function') {
      next = el;
      break;
    }
  }

  if (next) {
    next.focus();
    if (next instanceof HTMLInputElement || next instanceof HTMLTextAreaElement) {
      try {
        next.select?.();
      } catch {}
    }
  }
};
